import GridViewCreateDTO from "../types/GridViewCreateDTO";
import GridViewReadDTO from "../types/GridViewReadDTO";
import GridViewUpdateFilterSettingsDTO from "../types/GridViewUpdateFilterSettingsDTO";
import ApiClient from "../../../../../../lib/apiClient";

class GridViewApiClient {
  constructor(
    private _apiClient: ApiClient,
    private _pathToUserViewApi: string = "userview"
  ) {}

  fetchViews = async (gridId: string): Promise<GridViewReadDTO[]> => {
    return await this._apiClient.get<GridViewReadDTO[]>(
      `${this._pathToUserViewApi}/grid/${gridId}`
    );
  };

  createView = async (
    gridId: string,
    gridViewCreateDTO: GridViewCreateDTO
  ): Promise<GridViewReadDTO> => {
    return this._apiClient.post<GridViewReadDTO>(
      `${this._pathToUserViewApi}/grid/${gridId}`,
      gridViewCreateDTO
    );
  };

  updateViewFilterSettings = async (
    gridId: string,
    id: string,
    updateFilterSettingsDTO: GridViewUpdateFilterSettingsDTO
  ): Promise<void> => {
    return await this._apiClient.put(
      `${this._pathToUserViewApi}/grid/${gridId}/${id}/updatefiltersettings`,
      updateFilterSettingsDTO
    );
  };

  updateViewColumnSettings = async (
    gridId: string,
    id: string,
    columnSettings: string
  ): Promise<void> => {
    return await this._apiClient.put(
      `${this._pathToUserViewApi}/grid/${gridId}/${id}/updatecolumnsettings`,
      { columnSettings: columnSettings }
    );
  };

  updateViewMetricsSettings = async (
    gridId: string,
    id: string,
    metricsSettings: string
  ): Promise<void> => {
    return await this._apiClient.put(
      `${this._pathToUserViewApi}/grid/${gridId}/${id}/updatemetricsettings`,
      { metricsSettings: metricsSettings }
    );
  };

  setDefaultView = async (
    gridId: string,
    id: string
  ): Promise<GridViewReadDTO[]> => {
    return await this._apiClient.put(
      `${this._pathToUserViewApi}/grid/${gridId}/${id}/setdefault`
    );
  };
}

export default GridViewApiClient;
